import type { MegaPanel, NavItem } from "@/lib/content/types";

export type DesktopNavEntry =
  | { type: "link"; label: string; href: string }
  | { type: "mega"; label: string; href: string; panel: MegaPanel };

/**
 * Build desktop/mobile nav entries from CMS primaryNav.
 * Items with a megaPanel become mega triggers; others stay simple links.
 */
export function buildDesktopNav(
  navigation: NavItem[],
  options?: { omitContact?: boolean },
): DesktopNavEntry[] {
  return navigation
    .filter((item) => {
      if (!options?.omitContact) return true;
      return item.href !== "/contact" && item.label.toLowerCase() !== "contact";
    })
    .map((item) => {
      if (item.megaPanel && item.megaPanel.links.length > 0) {
        return {
          type: "mega" as const,
          label: item.label,
          href: item.href,
          panel: item.megaPanel,
        };
      }

      return { type: "link" as const, label: item.label, href: item.href };
    });
}
